import { FC } from 'react';
import { AdditionalInfo } from 'src/v1-components/shared/AdditionalInfo';
import additionalInfoItems from 'src/constants/additionalInfoItems';
import { Container } from './styles';

const AdditionalInfoContainer: FC = () => {
  return (
    <Container>
      <AdditionalInfo infoItems={additionalInfoItems} type="info" />
    </Container>
  );
};

export default AdditionalInfoContainer;
